/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyInfoVo,
  ResponseListCompanyInfoVo,
  ResponseString,
} from '../models/index';
import {
    CompanyInfoVoFromJSON,
    CompanyInfoVoToJSON,
    ResponseListCompanyInfoVoFromJSON,
    ResponseListCompanyInfoVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface CompanyInfoCreatePostRequest {
    companyInfoVo?: CompanyInfoVo;
}

export interface CompanyInfoListUserIdGetRequest {
    userId: number;
    nationId?: number;
}

/**
 * 
 */
export class CompanyInfoControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 创建公司信息
     */
    async companyInfoCreatePostRaw(requestParameters: CompanyInfoCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/companyInfo/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyInfoVoToJSON(requestParameters['companyInfoVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 创建公司信息
     */
    async companyInfoCreatePost(requestParameters: CompanyInfoCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.companyInfoCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 查询公司信息列表
     */
    async companyInfoListUserIdGetRaw(requestParameters: CompanyInfoListUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListCompanyInfoVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling companyInfoListUserIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/companyInfo/list/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListCompanyInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 查询公司信息列表
     */
    async companyInfoListUserIdGet(requestParameters: CompanyInfoListUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListCompanyInfoVo> {
        const response = await this.companyInfoListUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
